import { HttpClient } from '../httpClient';
import BooleanResponse from '../responses/booleanResponse';
import { BaseResponse } from '../responses/baseResponse';

const httpClient = new HttpClient();

export const checkApi = async () => {
  return httpClient.get<BaseResponse>({
    url: '/v1/status/ping',
    requiresToken: false,
  });
};

export const checkDb = async () => {
  return httpClient.get<BooleanResponse>({
    url: '/v1/status/dbcheck',
    requiresToken: false,
  });
};
